import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Container, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import { useStyles } from './common.styled';
import { useParams } from 'react-router-dom';
import { NFCDetailsWidget } from 'components/AccessDevice';
import Logs from 'components/Logs';
import { Details } from 'components/Customers';

export const NFCDetails = () => {
  const classes = useStyles();
  const { id } = useParams();
  const title = i18n.t('nfc.details_title', { accessDeviceId: id });
  const { accessDevice } = useSelector((state) => state.accessDevice);

  return (
    <Layout title={title}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
              <Grid item>
                <Typography variant="h1" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} mb={1}>
                    {title}
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item sm={12} md={6} lg={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <NFCDetailsWidget id={id} view="nfc" />
                  </Grid>
                  <Grid item xs={12}>
                    <Details id={accessDevice?.user?.id} viewOnly />
                  </Grid>
                  <Can I="read" a="comment">
                    <Grid item xs={12}>
                      <Comments type="access_device" id={parseInt(id)} />
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
              <Grid item sm={12} md={6} lg={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Logs
                      targetId={parseInt(id)}
                      targetType="AccessDevice"
                      title={i18n.t('nfc.logs')}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};
